import RegulationAPI from "api/RegulationAPI";
import useFetchData from "hooks/useFetchData";

export default function useRegulation( slug?: string ) {
   return useFetchData({
      APIMethod: RegulationAPI.bySlug,
      params: [ slug ],
      condition: !!slug
   })
}